module.exports = [{
      plugin: require('/Users/ivanvotti/Projects/contrib/svg-jar-lp/node_modules/gatsby-plugin-google-analytics/gatsby-browser.js'),
      options: {"plugins":[],"trackingId":"UA-30079697-2"},
    },{
      plugin: require('/Users/ivanvotti/Projects/contrib/svg-jar-lp/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
